/**
 * Public, customer-facing URLs and contact addresses — the single source.
 *
 * Every link a customer can follow out of the product (the help center, the marketing site, the
 * legal pages, the support page) is declared here once and imported everywhere else: the SPAs,
 * the API's emails, and the help center's `{{url:<key>}}` placeholders (apps/help). Never write
 * one of these literals in another file.
 *
 * Only public, environment-independent addresses belong here. Per-environment app hosts
 * (admin., visitor., auth.) are build-time env (`packages/config/vite/suite-app-urls.js`).
 */
export const PUBLIC_URLS = {
    /** Marketing site home. */
    marketing: 'https://instacheckin.io/',
    /** Contact form and support options on the marketing site. */
    support: 'https://instacheckin.io/support/',
    /** Pricing page — plan names and what each includes. */
    pricing: 'https://instacheckin.io/pricing/',
    terms: 'https://instacheckin.io/terms-of-service/',
    privacy: 'https://instacheckin.io/privacy-policy/',
    /** The customer help center (apps/help). */
    help: 'https://help.app.instacheckin.io/',
    /** The kiosk app's App Store listing. */
    kioskAppStore: 'https://apps.apple.com/us/app/instacheckin-visitor-kiosk/id6820398939',
};
export const PUBLIC_EMAILS = {
    support: 'support@instacheckin.io',
};
//# sourceMappingURL=public-urls.js.map